/* ComposesTable.styles.js */
import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
	table: {
		width: "100%",
		tableLayout: "fixed", 
	},

	colName: {
		width: "auto",
	},

	colChipset: {
		width: "15%",
	},
	colMode: {
		width: "15%",
	},
	colDevices: {
		width: "15%",
	},
	colActions: {
		width: "20%",
	},
	na: {
		color: theme.palette.text.disabled,
		fontStyle: "italic",
	},
	subheader : {
		color:theme.palette.amano.base.primary.main,
	}

}));